module.exports = __webpack_public_path__ + "static/media/fm-icons-Menu_close.729b72f5.svg";